module.exports = __webpack_public_path__ + "static/media/NoatecLogo.d6abff43.png";